export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://infinityapply.com").replace(/\/$/, "");

export const siteUrl = (path = "/") => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
